export const initialState = {
    is_loading: true,
    ftms_ratings: [],
    current_page: 1,
    serach_text: '',
    sort_key: '',
    sort_direction: '',
    total_ftms: 0,
    total_pages: 0,
    is_show_date_filter: false,
    start_date: '',
    end_date: '',
    error: null,
}